import xml2js from 'xml2js'

export default {
  name: 'MediaFeedParsers',
  methods: {
    parseMediaFeed: function (feedObj) {
      let res = {}
      if (typeof feedObj === 'string') {
        if (feedObj.includes('<?xml')) {
          const jsonObj = this.convertXmlToJson(feedObj)
          if (jsonObj.success === false) {
            res.success = false
            return res
          }
          //  check if object contains rss feed
          if (jsonObj.data.rss) {
            res = this.parseRssFeed(jsonObj.data)
            return res
          }
          // TODO check for other types of feeds
        }
      }
      return res
    },
    convertXmlToJson: function (xmlString) {
      const res = {}
      xml2js.parseString(xmlString, (err, result) => {
        if (err) {
          console.error('media feed parser: could not convert xml string to json object! ' + err)
          res.success = false
        } else {
          res.success = true
          res.data = result
        }
      })
      return res
    },
    parseRssFeed: function (mediaFeed) {
      console.debug('media feed parser: parsing georss feed..')
      const feedObject = {}
      feedObject.version = mediaFeed.rss.$.version
      feedObject.xml_base = mediaFeed.rss.$['xml:base']
      // Add the channel of the feed
      let success = false
      if (mediaFeed.rss.channel) {
        success = true
        feedObject.channel = {}
        const channel = mediaFeed.rss.channel[0]
        // Required fields
        feedObject.channel.title = channel.title[0]
        feedObject.channel.link = decodeURIComponent(channel.link[0])
        if ('description' in feedObject.channel) {
          feedObject.channel.description = channel.description[0]
        } else {
          feedObject.channel.description = ''
        }
        // Optional fields
        if (channel.pubDate) {
          feedObject.channel.pub_date = channel.pubDate[0]
        }
        if (channel['atom:link']) {
          feedObject.channel.atom_link = channel['atom:link'][0]
        }
        if (channel.category) {
          feedObject.channel.categories = []
          // Add categories used in this channel
          for (let j = 0; j < channel.category.length; j++) {
            feedObject.channel.categories.push(channel.category[j])
          }
        }
        if (channel.ttl) {
          feedObject.channel.ttl = channel.ttl[0]
        }
        if (channel.copyright) {
          feedObject.channel.copyright = channel.copyright[0]
        }
        if (channel.docs) {
          feedObject.channel.docs = channel.docs[0]
        }
        if (channel.managingEditor) {
          feedObject.channel.managing_editor = channel.managingEditor[0]
        }
        if (channel.webMaster) {
          feedObject.channel.web_master = channel.webMaster[0]
        }
        if (channel.language) {
          feedObject.channel.language = channel.language[0]
        }
        if (channel.generator) {
          feedObject.channel.generator = channel.generator[0]
        }
        // Image
        if (channel.image) {
          feedObject.channel.image = {}
          if (channel.image[0].url) {
            feedObject.channel.image.url = decodeURIComponent(channel.image[0].url[0])
          }
          if (channel.image[0].link) {
            feedObject.channel.image.link = channel.image[0].link[0]
          }
          if (channel.image[0].title) {
            feedObject.channel.image.title = channel.image[0].title[0]
          }
          if (channel.image[0].description) {
            feedObject.channel.image.description = channel.image[0].description[0]
          }
        }
        // Parse items
        feedObject.channel.items = []
        if (channel.item) {
          for (let k = 0; k < channel.item.length; k++) {
            const itemObject = {}
            const item = channel.item[k]
            itemObject.index = k
            if (item.title) {
              itemObject.title = item.title[0]
            }
            if (item.author) {
              itemObject.author = item.author[0]
            }
            if (item.description) {
              itemObject.description = item.description[0]
            }
            if (item.link) {
              itemObject.link = decodeURIComponent(item.link[0])
            }
            itemObject.categories = []
            if (item.category) {
              for (let l = 0; l < item.category.length; l++) {
                itemObject.categories.push(item.category[l])
              }
            }
            if (item.comments) {
              itemObject.comments = item.comments[0]
            }
            if (item.pubDate) {
              itemObject.pub_date = item.pubDate[0]
            }
            if (item.enclosure) {
              itemObject.media = {}
              itemObject.media.url = decodeURIComponent(item.enclosure[0].$.url)
              itemObject.media.size = item.enclosure[0].$.length
              itemObject.media.type = item.enclosure[0].$.type
            }
            // GeoRSS information
            // Note: Field names 'lat' and 'lng' enables Leaflet to directly use position from feed object
            if (item['georss:point']) {
              const position = item['georss:point'][0]
              const len = position.length
              const sep = position.indexOf(' ')
              itemObject.position = { lat: parseFloat(position.substring(0, sep)), lng: parseFloat(position.substring(sep + 1, len)) }
            } else if (item['geo:lat'] && item['geo:long']) {
              itemObject.position = { lat: parseFloat(item['geo:lat'][0]), lng: parseFloat(item['geo:long'][0]) }
            } else {
              itemObject.position = { lat: 0, lng: 0 }
            }
            feedObject.channel.items.push(itemObject)
          }
        }
      }
      const res = {}
      res.success = success
      res.data = feedObject
      return res
    }
  }
}
